import React from "react";

export const ProductBrand = () => {
  return (
    <div>
      <h2>Product Brand</h2>
    </div>
  );
};

export default ProductBrand;
